import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { Grid } from "@material-ui/core";
import {
  Box,
  Tab,
  Tabs,
  Card,
  CardHeader,
  Divider,
  CardContent,
} from "@mui/material";

import "../../styleSheets/App.css";
import {
  decodeBatteryStatus,
  decodeChargingStatus,
  decodeError,
  decodeError2,
  decodeInverterError,
  recDecoderError1,
  recDecoderError2,
} from "../../utility/statusdecoder";


const ColoredLine = (color) => {
  return <hr style={{ height: "2px", width: "80%", backgroundColor: color }} />;
};

const EMSInfo = () => {
  const [value, setValue] = useState(0);
  const { eachEMSData } = useSelector((state) => state);
  
  if (eachEMSData["PacketType"] === 2) return <div />;
  
  if(Object.keys(eachEMSData).length ==0) return (
    <div style={{
      padding: '20px',
      textAlign: 'center',
      fontSize: '18px',
      color: '#666',
      backgroundColor: '#f5f5f5',
      border: '1px solid #ddd',
      borderRadius: '5px',
      margin: '20px auto',
      width: 'fit-content',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <span style={{ fontWeight: 'bold', color: '#ff4444' }}>⚠️ This EMS is offline</span>
    </div>
  );
  
  let _Volt = Math.abs(eachEMSData["Voltage"][2] / 128).toFixed(3);
  let _amp = Math.abs(eachEMSData["BatteryCurrent"] / 1024).toFixed(3);
  let batteryCurrent = eachEMSData["BatteryCurrent"] / 1024;
  let _coulombIn = batteryCurrent < 0 ? Math.abs(batteryCurrent / 3).toFixed(3) : "0";
  let _coulombOut = batteryCurrent > 0 ? Math.abs(batteryCurrent / 3).toFixed(3) : "0";
  let _maxVolt = Math.abs(eachEMSData["Voltage"][1] / 1000).toFixed(3);
  let _minVolt = eachEMSData["Voltage"][0] / 1000;
  let _maxTemp = eachEMSData["Temp"][1];
  let _minTemp = eachEMSData["Temp"][0];
  let _openReset = eachEMSData["CanOpenResetCount"];
  let _batteryStatus = decodeBatteryStatus(eachEMSData["BatteryStatus"]);
  let _chargingStatus = decodeChargingStatus(eachEMSData["ChargerStatus"]);
  let _aVolt = Math.abs(
    eachEMSData["Rec"]["Volt"]["A"] / 128 / 1.73205
  ).toFixed(3);
  let _bVolt = Math.abs(
    eachEMSData["Rec"]["Volt"]["B"] / 128 / 1.73205
  ).toFixed(3);
  let _cVolt = Math.abs(
    eachEMSData["Rec"]["Volt"]["C"] / 128 / 1.73205
  ).toFixed(3);
  let _oVolt = Math.abs(
    eachEMSData["Rec"]["Volt"]["O"] / 128 
  ).toFixed(3);
  let _RecCurO = Math.abs(eachEMSData["Rec"]["Current"]["O"] / 1024).toFixed(3);
  let _RecVoltO = (eachEMSData["Rec"]["Volt"]["O"])/128;
  let RecPower = (_RecCurO * _RecVoltO)/1000;

  let _errMsg =
    decodeError(eachEMSData["ErrorMsg"]) +
    "," +
    decodeError2(eachEMSData["ErrorMsg2"]);
  let _RecErrMsg =
    recDecoderError1(eachEMSData["Rec"]["R_Err1"]) +
    "," +
    recDecoderError2(eachEMSData["Rec"]["R_Err2"]);
  console.log("Inverter Current: " +    eachEMSData["Inv"]["Curr"])
  console.log("Inverter Voltage: " +    eachEMSData["Inv"]["Volt"])
  let invCur = eachEMSData["Inv"]["Curr"] / 5;
  let invVolt = eachEMSData["Inv"]["Volt"] /// 5;
  let invPower = Math.abs((invCur * invVolt) / 1000).toFixed(3);
  let _bmsPower = (_amp * _Volt) / 1000;

  let chargerStatus = eachEMSData["chargerStatus"] & 0x03;
  console.log("Charging Status", chargerStatus);
  let powerObj = {
    current: _amp,
    cStatus: chargerStatus,
    RecPower,
    invPower,
    bmsPower: _bmsPower,
  };
  let dcInvPower = 0;
  if (powerObj["RecPower"] <= 0) {
    console.log("PowerObj: "+powerObj)
    dcInvPower = Math.abs(powerObj.bmsPower) - powerObj.invPower;
  } else if (
    powerObj["RecPower"] > 0 &&
    powerObj.cStatus == 0 &&
    powerObj.current >= +0.5
  ) {
    dcInvPower =
      (powerObj["RecPower"] + Math.abs(powerObj.bmsPower)) - powerObj.invPower;
   } else if (powerObj["RecPower"] > 0) {

    let _bmsPower= Math.abs(powerObj.bmsPower)
    let _dcInvPower =
      powerObj["RecPower"] - ( _bmsPower + parseFloat(powerObj.invPower));
    dcInvPower = _dcInvPower <= 0 ? 0 : _dcInvPower;
  }
  dcInvPower = Math.abs(dcInvPower).toFixed(3);

  const formatRawError = (value) => {
    if (value === undefined || value === null) return "N/A";
    return `0x${Number(value).toString(16).toUpperCase().padStart(2, "0")}`;
  };

  let batteryStatus = () => {
    return (
      <div>
        <table>
          <thead>
            <tr>
              <th style={{
                border: 'solid 1px black',
                padding:'9px',
                color: 'black',
                backgroundColor: '#7AA2E3',
              }} >Battery</th>
              <th>
                <table>
                <thead>
                  <tr>
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                      MainContactor
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                       Charging Contactor
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                     Weekend Cycle
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                     Balancing Status
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                    Charging Status
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                    Estimated Time
                    </th>
                  </tr>                
                </thead>
                <tbody>
                    <tr>
                      <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontStyle:'normal',
                        fontSize:'12px'
                      }}
                      >
                        {_batteryStatus[0].split('|')[0]}
                      </td>
                      <td
                       style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                      {_batteryStatus[0].split('|')[1]}
                      </td>
                     <td
                       style={{
                        padding: '10px',
                        border: 'solid 1px gray',                        
                        fontSize:'12px'
                      }}
                      >
                      {_batteryStatus[2]}
                      </td>
                      <td
                       style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                        {_batteryStatus[1]}
                      </td>
                    <td
                       style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                        {_chargingStatus}
                      </td>
                      <td
                      style={{
                       padding: '10px',
                       border: 'solid 1px gray',
                       fontSize:'12px'
                     }}
                     >
                       2 hrs
                     </td>
                    </tr>
                    <tr>
                     <td style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}
                     >
                      Ampere
                     </td>
                     <td style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}
                     >
                      Voltage
                     </td>
                     <td style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}
                     >
                      kiloWatt
                     </td>
                     <td style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}
                     >
                      SoC
                     </td>
                     <td style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}
                     >
                      SOH
                     </td>
                     <td style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}
                     >
                      CanOpenReset
                     </td>
                    
                    </tr>
                    <tr>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                      {_amp}
                      </td>
                     <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                      {_Volt}
                      </td>
                    <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                      {Math.abs(_bmsPower).toFixed(3)}
                      </td>
                     <td style={{
                        padding: '10px',
                        fontSize:'12px',
                        border: 'solid 1px gray',
                      }}>
                      {eachEMSData["BatterySOC"]}
                      </td>
                    <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                      Good
                      </td>
                    <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                      0
                      </td>
                    </tr> 
                    <tr>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Vcell(max)
                    </td>
                     <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'

                    }}>
                      Vcell(min)
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Tcell(max)
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Tcell(min)
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Error1
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Error2
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Error1 Raw Code
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Error2 Raw Code
                      </td>
                    </tr>
                    <tr>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { _maxVolt}
                      </td>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { _minVolt}
                      </td>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { _maxTemp}
                      </td>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { _minTemp}
                      </td>
                    <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { decodeError(eachEMSData["ErrorMsg"])}
                      </td>
                    <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { decodeError2(eachEMSData["ErrorMsg2"])}
                      </td>
                    <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { formatRawError(eachEMSData["ErrorMsg"])}
                      </td>
                    <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { formatRawError(eachEMSData["ErrorMsg2"])}
                      </td>
                    </tr>
                <tr>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Restored Error1 (MB1)
                    </td>
                     <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'

                    }}>
                      Restored Error2 (MB2)
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      AH Cycle Count
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      AH Partial Count
                      </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Coulomb In
                    </td>
                    <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                    }}>
                      Coulomb Out
                    </td>
                    </tr>
                    <tr>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { eachEMSData["ResErr"]["MB1"]}
                      </td>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { eachEMSData["ResErr"]["MB2"]}
                      </td>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { eachEMSData["AH_data"]["Cycle"]}
                      </td>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { eachEMSData["AH_data"]["AHpartial"]}
                      </td>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { _coulombIn}
                      </td>
                      <td style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}>
                        { _coulombOut}
                      </td>
                    </tr>                   
                </tbody>  
                </table>
              </th>
            </tr>
          </thead>
        </table>
        </div>
    );
  };

  let rectifierStatus = () => {
    return (
      <div>
        <table>
          <thead>
            <tr>
              <th style={{
                border: 'solid 1px black',
                padding:'5px',
                color: 'black',
                backgroundColor: '#7AA2E3',
              }} >Rectifier</th>
              <th>
                <table>
                  <thead>
                    <tr>
                      <th style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}>
                        PhaseA Voltage
                      </th>
                      
                      <th style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}>
                        PhaseB Voltage
                      </th>
                      
                      <th style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}>
                      PhaseC Voltage
                      </th>
                      
                      <th style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}>
                      DC KW-in
                      </th>
                      
                      <th style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}>
                      Current In
                      </th>
                      
                      <th style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}>
                      DC KW-out
                      </th>
                    </tr>                
                  </thead>
                  <tbody>
                      <tr>
                        <td
                        style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontStyle:'normal',
                          fontSize:'12px'
                        }}
                        >
                          {_aVolt}
                        </td>
                        <td
                        style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}
                        >
                        {_bVolt}
                        </td>
                      <td
                        style={{
                          padding: '10px',
                          border: 'solid 1px gray',                        
                          fontSize:'12px'
                        }}
                        >
                        {_cVolt}
                        </td>
                        <td
                        style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}
                        >
                          {eachEMSData["Rec"]["Pow"]["I"]}
                        </td>
                      <td
                        style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}
                        >
                          {eachEMSData["Rec"]["Current"]["I"]}
                        </td>
                        <td
                        style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                      {Math.abs(RecPower).toFixed(3)}
                      </td>
                      </tr>
                      <tr>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        Current out
                      </td>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        DC Voltage Out
                      </td>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        Temperature
                      </td> 
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        Error1
                      </td>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        Error2
                      </td>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        Error1 Raw Code
                      </td>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        Error2 Raw Code
                      </td>
                      </tr>
                      <tr>
                        <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        {_RecCurO}
                        </td>
                      <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        {Math.abs(_RecVoltO).toFixed(3)}
                        </td>
                      <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        {eachEMSData["Rec"]["Temp"]} °C
                        </td>
                      <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        {recDecoderError1(eachEMSData["Rec"]["R_Err1"])}
                        </td>
                      <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        { recDecoderError2(eachEMSData["Rec"]["R_Err2"])}
                        </td>
                      <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        { formatRawError(eachEMSData["Rec"]["R_Err1"])}
                        </td>
                      <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        { formatRawError(eachEMSData["Rec"]["R_Err2"])}
                        </td>
                     </tr>
                    <tr>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        Restored Error1 (RE1)
                      </td>
                      <td style={{
                        border: 'solid 1px black',
                        padding:'10px',
                        color: 'black',
                        backgroundColor: '#97E7E1',
                        fontSize:'12px'
                      }}
                      >
                        Restored Error2 (RE2)
                      </td>
                      </tr>
                      <tr>
                        <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        {eachEMSData["ResErr"]["RE1"]}
                        </td>
                      <td style={{
                          padding: '10px',
                          border: 'solid 1px gray',
                          fontSize:'12px'
                        }}>
                        {eachEMSData["ResErr"]["RE2"]}
                        </td>
                     </tr> 
                      
                  </tbody>  
                </table>
              </th>
            </tr>
          </thead>
        </table>
        </div>
    );
  
  
  };

  let inverterStatus = () => {
    return (
      <div>
        <table>
          <thead>
            <tr>
            <th style={{
              border: 'solid 1px black',
              padding:'8px',
              color: 'black',
              backgroundColor: '#7AA2E3',
            }} >Inverter</th>
            <th>
              <table>
                <thead>
                  <tr>
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                     Ampere
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                      Voltage
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                    INV-Kw
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                    DC KW
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                    Heatsink Temp
                    </th>
                    
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                      Transformer Temp
                    </th>
                  </tr>                
                </thead>
                <tbody>
                    <tr>
                      <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontStyle:'normal',
                        fontSize:'12px'
                      }}
                      >
                        {invCur}
                      </td>
                      <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                      {invVolt}
                      </td>
                    <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',                        
                        fontSize:'12px'
                      }}
                      >
                      {invPower}
                      </td>
                      <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                        {dcInvPower}
                      </td>
                    <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                        {eachEMSData["Inv"]["T_HS"]} °C
                      </td>
                      <td
                      style={{
                      padding: '10px',
                      border: 'solid 1px gray',
                      fontSize:'12px'
                    }}
                    >
                    {eachEMSData["Inv"]["T_amb"]} °C
                    </td>
                    </tr>
                    <tr>
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                     Error
                    </th>
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                      Error Raw Code
                    </th>
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                      Restored Error (IER)
                    </th>
                   </tr>
                  <tr>
                  <td
                  style={{
                    padding: '10px',
                    border: 'solid 1px gray',
                    fontStyle:'normal',
                    fontSize:'12px'
                  }}
                  >
                    {decodeInverterError(eachEMSData["Inv"]["Err"])}
                  </td>
                  <td
                  style={{
                    padding: '10px',
                    border: 'solid 1px gray',
                    fontSize:'12px'
                  }}
                  >
                  {formatRawError(eachEMSData["Inv"]["Err"])}
                  </td>
                  <td
                  style={{
                    padding: '10px',
                    border: 'solid 1px gray',
                    fontSize:'12px'
                  }}
                  >
                  {eachEMSData["ResErr"]["IER"]}
                  </td>
                </tr>

                    </tbody>  
              </table>
            </th>
            </tr>
          </thead>
        </table>
      </div>
    );
  };

  let solarStatus = () => {
    return (
      <div>
        <table>
          <thead>
            <tr>
            <th style={{
              border: 'solid 1px black',
              padding:'8px',
              color: 'black',
              backgroundColor: '#7AA2E3',
            }} >Solar</th>
            <th>
              <table>
                <thead>
                  <tr>
                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                     Voltage
                    </th>

                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                      Current
                    </th>

                    <th style={{
                      border: 'solid 1px black',
                      padding:'10px',
                      color: 'black',
                      backgroundColor: '#97E7E1',
                      fontSize:'12px'
                    }}>
                    Energy
                    </th>
                  </tr>
                </thead>
                <tbody>
                    <tr>
                      <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontStyle:'normal',
                        fontSize:'12px'
                      }}
                      >
                        {eachEMSData["Solar"]["V"]}
                      </td>
                      <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                      {eachEMSData["Solar"]["I"]}
                      </td>
                    <td
                      style={{
                        padding: '10px',
                        border: 'solid 1px gray',
                        fontSize:'12px'
                      }}
                      >
                      {eachEMSData["Solar"]["E"]}
                      </td>
                    </tr>
                    </tbody>
              </table>
            </th>
            </tr>
          </thead>
        </table>
      </div>
    );
  };

  return eachEMSData != undefined ? (

      <div>
        <Grid item>{batteryStatus()}</Grid>
        <Divider />
        <Grid item>{rectifierStatus()}</Grid>
        <Divider />
        <Grid item>{inverterStatus()}</Grid>
        {eachEMSData["Solar"] ? (
          <>
            <Divider />
            <Grid item>{solarStatus()}</Grid>
          </>
        ) : null}
      </div>
  ) : null;
};

export default EMSInfo;
